import Vue from 'vue'
import { PopupManager } from 'element-ui/src/utils/popup'
import PrintVue from './index.vue'
const PrintConstructor = Vue.extend(PrintVue) // 直接将Vue组件作为Vue.extend的参数

let instance
const instances = []
let seed = 1

const Print = (options) => {
  options = options || {}
  const id = 'print_' + seed++
  instance = new PrintConstructor({
    data: options
  }) // 实例化
  instance.id = id
  instance.$mount()
  document.body.appendChild(instance.$el)
  // instance.visible = true
  // instance.$el.style.zIndex = PopupManager.nextZIndex()
  instances.push(instance)

  return instance
}
Print.closeAll = function() {
  for (let i = instances.length - 1; i >= 0; i--) {
    instances[i].$destroy(true)
  }
}

export default {
  install: Vue => {
    Vue.prototype.$print = Print // 将组件暴露出去，并挂载在Vue的prototype上
  }
}
